import { __rest } from "tslib";
import classnames from 'classnames';
import React from 'react';
import color from '../../images/logos/logo-color.svg';
import dark from '../../images/logos/logo-dark.svg';
import light from '../../images/logos/logo-light.svg';
export const Logos = { light, dark, color };
export const Logo = (_a) => {
    var { type, logoSize, className } = _a, props = __rest(_a, ["type", "logoSize", "className"]);
    const sizeClass = logoSize ? `logo--${logoSize}` : null;
    const klass = classnames('logo', className, sizeClass);
    const Logo = Logos[type];
    return React.createElement(Logo, Object.assign({}, props, { className: klass }));
};
//# sourceMappingURL=index.js.map